module.exports = __webpack_public_path__ + "static/media/Government.0c44eb47.svg";